import { render, staticRenderFns } from "./pay-review.vue?vue&type=template&id=371de538&scoped=true"
import script from "./pay-review.vue?vue&type=script&lang=js"
export * from "./pay-review.vue?vue&type=script&lang=js"
import style0 from "./pay-review.vue?vue&type=style&index=0&id=371de538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371de538",
  null
  
)

export default component.exports